<ngx-skeleton-loader
        class="skeleton-loader image"
        [theme]="{
            'height': '140.34px',
            'width': '100%',
            'background-color': 'var(--skeleton-background-color)',
            'foregroundColor': 'red',
            'margin-bottom': '5px',
            'border-radius': '0'
        }"
></ngx-skeleton-loader>
<ngx-skeleton-loader
        class="skeleton-loader price"
        [theme]="{
            'height': '16px',
            'width': '50px',
            'background-color': 'var(--skeleton-background-color)',
            'margin-bottom': '5px'
        }"
></ngx-skeleton-loader>
<ngx-skeleton-loader
        class="skeleton-loader code"
        [theme]="{
            'height': '13px',
            'width': '55px',
            'background-color': 'var(--skeleton-background-color)',
            'margin-bottom': '5px'
        }"
></ngx-skeleton-loader>
<ngx-skeleton-loader
        class="skeleton-loader name"
        count="2"
        appearance="line"
        [theme]="{
            'height': '16px',
            'background-color': 'var(--skeleton-background-color)'
        }"
></ngx-skeleton-loader>
<ngx-skeleton-loader
        class="skeleton-loader button"
        appearance="line"
        [theme]="{
            'height': '39px',
            'background-color': 'var(--skeleton-background-color)',
            'margin-bottom': '0',
            'border-radius': '0'
        }"
></ngx-skeleton-loader>